{
  "jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "jsm-project-summary-onboarding.changeLayout": [
    {
      "type": 0,
      "value": "Change the layout and order of charts"
    }
  ],
  "jsm-project-summary-onboarding.closeButton": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "jsm-project-summary-onboarding.description": [
    {
      "type": 0,
      "value": "You can now edit the summary page to keep your team up to date. Tailor your space overview by customizing the layout, filters, and charts."
    }
  ],
  "jsm-project-summary-onboarding.editFilters": [
    {
      "type": 0,
      "value": "Edit filters"
    }
  ],
  "jsm-project-summary-onboarding.heading": [
    {
      "type": 0,
      "value": "Edit your space summary"
    }
  ],
  "jsm-project-summary-onboarding.hideAddCharts": [
    {
      "type": 0,
      "value": "Hide or add charts"
    }
  ],
  "jsm-project-summary-onboarding.moreAboutFeature": [
    {
      "type": 0,
      "value": "More about space summary"
    }
  ],
  "jsm-project-summary-onboarding.okButton": [
    {
      "type": 0,
      "value": "Got it"
    }
  ],
  "jsm-project-summary-onboarding.whatsNewTitle": [
    {
      "type": 0,
      "value": "What’s new?"
    }
  ]
}